import { getVideoMetadata } from "@/app/actions";
import { Content } from "@/services/content/types";
import { prefixSlug } from "@/utils/url";
import classNames from "classnames";
import Link from "next/link";
import { formatDuration } from "../duration";
import Icon from "../icon";
import TeaserHeading from "../teaser-heading";
import VideoThumbnail from "../video-thumbnail";

const Play = async ({
  play,
  compactMode = false,
  darkMode = true,
  fontWeight = "font-semibold",
  hideThumbnailImage = false,
}: {
  play: Content.Play;
  compactMode?: boolean;
  darkMode?: boolean;
  fontWeight?: string;
  hideThumbnailImage?: boolean;
}) => {
  const videoId = play.fields.quickchannelIds?.[0] || play.fields.videos?.[0];

  const videoMetadata = videoId
    ? await getVideoMetadata({
        qbrick: play.fields.videos?.[0],
        quickchannel: play.fields.quickchannelIds?.[0],
      })
    : null;

  const title = play.fields.teaserTitle || play.fields.title;
  const image = play.fields.teaserImage || play.fields.image;

  return (
    <Link
      href={prefixSlug(play.fields.slug, play.sys.contentType.sys.id)}
      className={classNames(
        "flex group relative gap-4 border-sand-800 !border-b",
        compactMode ? "" : "",
        darkMode ? "!border-static-black-300  bg-static-black-400 !pt-0" : "",
        !compactMode ? "" : "",
      )}
    >
      {image?.fields?.file?.url && !hideThumbnailImage && (
        <div
          className={classNames(
            "relative bg-sand-600 overflow-hidden",
            compactMode
              ? "w-[107px] h-[60px] md:w-[65px] md:h-[37px]"
              : "w-[107px] h-[60px] md:w-[150px] md:h-[84px] ",
          )}
        >
          <VideoThumbnail
            className="object-cover"
            fallbackUrl={videoMetadata?.thumbnail}
            thumbnailImage={image}
            aiLabelSize="sm"
          />
        </div>
      )}
      <div className={classNames("flex-1", compactMode ? "" : "")}>
        {title && (
          <TeaserHeading
            text={title}
            className={classNames(
              "break-words group-hover:underline",
              fontWeight ? fontWeight : "font-semibold",
              darkMode ? "text-static-white" : "",
              compactMode ? "text-lg" : " text-lg lg:text-2xl",
            )}
          />
        )}

        <div className="flex items-center text-sm mt-2">
          <Icon.PlayInverted
            className="w-4 h-4 mr-1 fill-white-500"
            bgClassName="fill-red-700"
            aria-label="Video"
          />
          {videoMetadata?.duration && (
            <span className="ml-1">{`(${formatDuration(
              videoMetadata.duration,
            )})`}</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default Play;
